import AddIcon from "@mui/icons-material/Add";
import classNames from "classnames";

export default function PiBasicQuizAddAnswerButtonV2(props: {
  onClick: () => void;
  disabled?: boolean;
  text?: string;
}) {
  const { onClick, disabled, text } = { ...props };

  return (
    <button
      className={classNames({
        "flex relative justify-center w-full border-b-2 border-dashed h-[68px] bg-interaction-softBackground border-interaction-primary gap-[12px] focus:outline-none":
          true,
        "cursor-pointer hover:bg-interaction-primary-washed": !disabled,
        "cursor-not-allowed": disabled,
      })}
      disabled={disabled}
      onClick={onClick}
    >
      <div
        className={classNames({
          "flex my-auto text-white rounded-full w-[36px] h-[36px]": true,
          "bg-interaction-primary": !disabled,
          "bg-interaction-disabled": disabled,
        })}
      >
        <AddIcon className={"m-auto"} />
      </div>
      {text && (
        <div
          className={"my-auto font-medium text-[18px] text-interaction-primary"}
        >
          {text}
        </div>
      )}
    </button>
  );
}
